import React from "react";

const Footer = () => {
  return (
    <div className="bg-black flex justify-between gap-6 px-3 mt-24 w-full md:px-11 max-w-[1935px] max-sm:py-[1rem] sm:py-[30px] font-inter mx-auto">
      <div className="text-white text-sm max-sm:text-[10px] min-w-full text-center">
        © 2024 SentioCap. All rights reserved.
      </div>
    </div>
  );
};

export default Footer;
